import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { X } from "react-feather";
import { UncontrolledTooltip } from "reactstrap";

function BrandsDetailsDrawer({ isOpen, brand, onClose }) {
  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      direction="right"
      className="p-3 w-25"
    // enableOverlay={false}
    >
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h3>{brand?.name}</h3>
        <button className="btn" onClick={onClose}>
          <X />
        </button>
      </div>
      <div style={{ overflow: "auto", height: "87vh" }}>
        <h5
          className="border-bottom pt-4 pb-2"
          style={{ fontWeight: "bold" }}
        >
          Standard Fields{" "}
          <div
            className="d-inline p-1 rounded"
            style={{
              fontSize: "12px",
              fontWeight: "bold",
              color: "#76B276",
              backgroundColor: "#e8f5e9",
            }}
          >
            AI Predicted
          </div>
        </h5>
        <div className="d-flex align-items-center border-bottom py-2">
          <h6 style={{ fontWeight: "bold", flex: 0.6 }} className="flex-1">
            Brand:
          </h6>
          <h6
            style={{
              flex: 1,
              // display: "-webkit-box",
              // overflow: "hidden",
              // WebkitBoxOrient: "vertical",
              // WebkitLineClamp: 3,
              lineHeight: 1.4,
            }}
            className="flex-1"
          >
            {brand?.name}
          </h6>
        </div>
        <div className="d-flex align-items-center border-bottom py-2">
          <h6 style={{ fontWeight: "bold", flex: 0.6 }} className="flex-1">
            Location:
          </h6>
          <h6
            style={{
              flex: 1,
              // display: "-webkit-box",
              // overflow: "hidden",
              // WebkitBoxOrient: "vertical",
              // WebkitLineClamp: 3,
              lineHeight: 1.4,
            }}
            id="market"
            className="flex-1"
          >
            {brand?.country || "--"}
          </h6>
          <UncontrolledTooltip placement="left" target="market">
            {brand?.country || "--"}
          </UncontrolledTooltip>
        </div>
        <div className="d-flex align-items-center border-bottom py-2">
          <h6 style={{ fontWeight: "bold", flex: 0.6 }} className="flex-1">
            Prefered Market:
          </h6>
          <h6
            style={{
              flex: 1,
              // display: "-webkit-box",
              // overflow: "hidden",
              // WebkitBoxOrient: "vertical",
              // WebkitLineClamp: 3,
              lineHeight: 1.4,
            }}
            id="preferred_market"
            className="flex-1"
          >
            {brand?.preferred_market?.join(", ")}
          </h6>
          <UncontrolledTooltip placement="left" target="preferred_market">
            {brand?.preferred_market?.join(", ")}
          </UncontrolledTooltip>
        </div>
        <div className="d-flex align-items-center border-bottom py-2">
          <h6 style={{ fontWeight: "bold", flex: 0.6 }} className="flex-1">
            Target Category:
          </h6>
          <div
            className="d-flex align-items-center justify-content-start gap-1"
            style={{ flexWrap: "wrap", flex: 1 }}
          >
            {[...(brand?.target_group || [])]
              .sort((a, b) =>
                a.toLowerCase() === "men"
                  ? -1
                  : b.toLowerCase() === "men"
                    ? 1
                    : 0
              )
              ?.map((target_group) => {
                const isMain =
                  target_group?.toLowerCase() ===
                  brand?.main_target_group?.toLowerCase();
                return (
                  <h6
                    style={{
                      lineHeight: 1.4,
                      padding: "0px 10px",
                      borderRadius: "25px",
                      backgroundColor: isMain ? "#fcedc0" : "transparent",
                      color: isMain ? "#e8b009" : "black",
                    }}
                    id="age"
                  >
                    {target_group}
                  </h6>
                );
              })}
          </div>
        </div>
        <div className="d-flex align-items-center border-bottom py-2">
          <h6 style={{ fontWeight: "bold", flex: 0.6 }} className="flex-1">
            Product Category:
          </h6>
          <div
            className="d-flex align-items-center justify-content-start gap-1"
            style={{ flexWrap: "wrap", flex: 1 }}
          >
            {brand?.product_category?.map((category) => {
              const isMain =
                category?.toLowerCase() ===
                brand?.main_category?.toLowerCase();
              return (
                <h6
                  style={{
                    lineHeight: 1.4,
                    padding: "0px 10px",
                    borderRadius: "25px",
                    backgroundColor: isMain ? "#fcedc0" : "transparent",
                    color: isMain ? "#e8b009" : "black",
                  }}
                  id="age"
                >
                  {category}
                </h6>
              );
            })}
          </div>
        </div>
        <div className="d-flex align-items-center border-bottom py-2">
          <h6 style={{ fontWeight: "bold", flex: 0.6 }} className="flex-1">
            Product Style:
          </h6>
          <div
            className="d-flex align-items-center justify-content-start gap-1"
            style={{ flexWrap: "wrap", flex: 1 }}
          >
            {brand?.style?.map((style) => {
              const isMain =
                style?.toLowerCase() === brand?.main_style?.toLowerCase();
              return (
                <h6
                  style={{
                    lineHeight: 1.4,
                    padding: "0px 10px",
                    borderRadius: "25px",
                    backgroundColor: isMain ? "#fcedc0" : "transparent",
                    color: isMain ? "#e8b009" : "black",
                  }}
                  id="age"
                >
                  {style}
                </h6>
              );
            })}
          </div>
        </div>
        <div className="d-flex align-items-center border-bottom py-2">
          <h6 style={{ fontWeight: "bold", flex: 0.6 }} className="flex-1">
            Age group:
          </h6>
          <div
            className="d-flex align-items-center justify-content-start gap-1"
            style={{ flexWrap: "wrap", flex: 1 }}
          >
            {brand?.age?.map((age) => {
              const isMain =
                age?.toLowerCase() === brand?.main_age?.toLowerCase();
              return (
                <h6
                  style={{
                    lineHeight: 1.4,
                    padding: "0px 10px",
                    borderRadius: "25px",
                    backgroundColor: isMain ? "#fcedc0" : "transparent",
                    color: isMain ? "#e8b009" : "black",
                  }}
                  id="age"
                >
                  {age}
                </h6>
              );
            })}
          </div>
        </div>
        <div className="d-flex align-items-center border-bottom py-2">
          <h6 style={{ fontWeight: "bold", flex: 0.6 }} className="flex-1">
            Price Range:
          </h6>
          <h6
            style={{
              flex: 1,
              // display: "-webkit-box",
              // overflow: "hidden",
              // WebkitBoxOrient: "vertical",
              // WebkitLineClamp: 3,
              lineHeight: 1.4,
            }}
            id="price"
            className="flex-1"
          >
            {brand?.price?.join(", ")}
          </h6>
          <UncontrolledTooltip placement="left" target="price">
            {brand?.price?.join(", ")}
          </UncontrolledTooltip>
        </div>
        <div className="d-flex align-items-center border-bottom py-2">
          <h6 style={{ fontWeight: "bold", flex: 0.6 }} className="flex-1">
            Price Point:
          </h6>
          <h6
            style={{
              flex: 1,
              // display: "-webkit-box",
              // overflow: "hidden",
              // WebkitBoxOrient: "vertical",
              // WebkitLineClamp: 3,
              lineHeight: 1.4,
            }}
            id="price_point"
            className="flex-1"
          >
            {brand?.price_point}
          </h6>
          <UncontrolledTooltip placement="left" target="price_point">
            {brand?.price_point}
          </UncontrolledTooltip>
        </div>

        <div className="d-flex align-items-center border-bottom py-2">
          <h6 style={{ fontWeight: "bold", flex: 0.6 }} className="flex-1">
            Brand Rating:
          </h6>
          <h6
            style={{
              flex: 1,
              // display: "-webkit-box",
              // overflow: "hidden",
              // WebkitBoxOrient: "vertical",
              // WebkitLineClamp: 3,
              lineHeight: 1.4,
            }}
            id="brand_rating"
            className="flex-1"
          >
            {brand?.brand_rating || brand?.brand_rating === 0
              ? Math.ceil(brand?.brand_rating).toFixed()
              : "--"}
          </h6>
          <UncontrolledTooltip placement="left" target="price_point">
            {Math.ceil(brand?.brand_rating).toFixed()}
          </UncontrolledTooltip>
        </div>

        <div className="d-flex align-items-center border-bottom py-2">
          <h6 style={{ fontWeight: "bold", flex: 0.6 }} className="flex-1">
            Brand Awareness:
          </h6>
          <h6
            style={{
              flex: 1,
              // display: "-webkit-box",
              // overflow: "hidden",
              // WebkitBoxOrient: "vertical",
              // WebkitLineClamp: 3,
              lineHeight: 1.4,
            }}
            id="brand_awareness"
            className="flex-1"
          >
            {brand?.brand_awareness || brand?.brand_awareness === 0
              ? Math.ceil(brand?.brand_awareness).toFixed()
              : "--"}
          </h6>
          <UncontrolledTooltip placement="left" target="price_point">
            {brand?.brand_awareness}
          </UncontrolledTooltip>
        </div>
        <div className="d-flex align-items-center border-bottom py-2">
          <h6 style={{ fontWeight: "bold", flex: 0.6 }} className="flex-1">
            Ecom Rating:
          </h6>
          <h6
            style={{
              flex: 1,
              // display: "-webkit-box",
              // overflow: "hidden",
              // WebkitBoxOrient: "vertical",
              // WebkitLineClamp: 3,
              lineHeight: 1.4,
            }}
            id="ecom_rating"
            className="flex-1"
          >
            {brand?.ecom_rating || brand?.ecom_rating === 0
              ? Math.ceil(brand?.ecom_rating).toFixed()
              : "--"}
          </h6>
          <UncontrolledTooltip placement="left" target="price_point">
            {brand?.ecom_rating}
          </UncontrolledTooltip>
        </div>

        <div className="d-flex align-items-center border-bottom py-2">
          <h6 style={{ fontWeight: "bold", flex: 0.6 }} className="flex-1">
            Market Diversity:
          </h6>
          <h6
            style={{
              flex: 1,
              // display: "-webkit-box",
              // overflow: "hidden",
              // WebkitBoxOrient: "vertical",
              // WebkitLineClamp: 3,
              lineHeight: 1.4,
            }}
            id="market_diversity"
            className="flex-1"
          >
            {brand?.market_diversity || brand?.market_diversity === 0
              ? Math.ceil(brand?.market_diversity).toFixed()
              : "--"}
          </h6>
          <UncontrolledTooltip placement="left" target="price_point">
            {brand?.market_diversity}
          </UncontrolledTooltip>
        </div>
        <div className="d-flex align-items-center border-bottom py-2">
          <h6 style={{ fontWeight: "bold", flex: 0.6 }} className="flex-1">
            POS Rating:
          </h6>
          <h6
            style={{
              flex: 1,
              // display: "-webkit-box",
              // overflow: "hidden",
              // WebkitBoxOrient: "vertical",
              // WebkitLineClamp: 3,
              lineHeight: 1.4,
            }}
            id="pos_rating"
            className="flex-1"
          >
            {brand?.pos_rating || brand?.pos_rating === 0
              ? Math.ceil(brand.pos_rating).toString()
              : "--"}
          </h6>
          <UncontrolledTooltip placement="left" target="price_point">
            {brand?.pos_rating}
          </UncontrolledTooltip>
        </div>
        <h5
          className="border-bottom pt-4 pb-2"
          style={{ fontWeight: "bold" }}
        >
          Addtional Properties
        </h5>
        {/* <div className="d-flex align-items-center border-bottom py-2">
          <h6 style={{ fontWeight: "bold", flex: 0.6 }} className="flex-1">
            Pitti Style:
          </h6>
          <h6
            style={{
              flex: 1,
              // display: "-webkit-box",
              // overflow: "hidden",
              // WebkitBoxOrient: "vertical",
              // WebkitLineClamp: 3,
              lineHeight: 1.4,
            }}
            id="pitti_style"
            className="flex-1"
          >
            {brand?.pitti_style || "--"}
          </h6>
        </div> */}
      </div>
    </Drawer>
  );
}

export default BrandsDetailsDrawer;
